"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actionCtxFill = exports.transactionType = void 0;
exports.transactionType = [
    "prepended",
    "token",
    "transfer",
    "construction",
    "add construction actions",
    "prepare construction",
    "action calls",
    "cleanup",
    "unknown",
];
const actionCtxFill = (c) => {
    return Object.assign({}, c);
};
exports.actionCtxFill = actionCtxFill;
